module.exports = __webpack_public_path__ + "static/media/twitter.adecc6d1.svg";